export const myLeaveRequestConstants = {
    GET_LEAVE_TYPE_SUCCESS: "GET_LEAVE_TYPE_SUCCESS",
    GET_SUMMARY_SUCCESS: "GET_SUMMARY_SUCCESS",
    GET_REQUEST_LIST_SUCCESS: "GET_REQUEST_LIST_SUCCESS",
    GET_REQUEST_LIST: "GET_REQUEST_LIST",
    GET_REQUEST_LIST_PAGE: "GET_REQUEST_LIST_PAGE",
    UPDATE_CONFIRM: "UPDATE_CONFIRM",
    UPDATE_CONFIRM_SUCCESS: "UPDATE_CONFIRM_SUCCESS",
    UPDATE_CONFIRM_FAIL: "UPDATE_CONFIRM_FAIL",
    CLEAR_MESSAGE: "CLEAR_MESSAGE",
};

export const leaveStatus = {
    SUBMITED: 0,
    APPROVED: 1,
    REJECTED: 2,
};

export const leaveStatusLabel = {
    0: "Submitted",
    1: "Approved",
    2: "Rejected",
};
